import React from "react";
import type { LucideIcon } from "lucide-react";
import { cn } from "../../../utils/cn";

type DashboardEmptyStateAlign = "start" | "center";

interface DashboardEmptyStateProps {
  title: string;
  description?: string;
  icon?: LucideIcon;
  align?: DashboardEmptyStateAlign;
  action?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
}

export default function DashboardEmptyState({
  title,
  description,
  icon: Icon,
  align = "start",
  action,
  footer,
  className,
}: DashboardEmptyStateProps) {
  const isCentered = align === "center";

  return (
    <div
      className={cn(
        "rounded-2xl border border-dashed border-white/[0.08] bg-[#1c2128]/60 p-4 sm:p-5",
        isCentered && "flex flex-col items-center text-center",
        className
      )}
    >
      {Icon && (
        <Icon
          className={cn(
            "h-7 w-7 shrink-0 text-[#6e7681]",
            isCentered ? "mb-3" : "mb-2"
          )}
          aria-hidden
        />
      )}

      <p className="text-sm font-semibold text-[#f0f6fc]">{title}</p>

      {description && (
        <p
          className={cn(
            "mt-1 text-xs leading-relaxed text-[#8b949e] sm:text-sm",
            isCentered ? "max-w-sm" : "max-w-prose"
          )}
        >
          {description}
        </p>
      )}

      {action && (
        <div className={cn("mt-3", isCentered && "flex justify-center")}>{action}</div>
      )}

      {footer && <div className="mt-3">{footer}</div>}
    </div>
  );
}
